export const refreshApi = (callback, time = 5) => {
  setInterval(() => {
    callback(Math.random())
  }, 1000 * time)
}
